<template>
    <span>
        {{ row.gotenna_version }}<template v-if="row.build_number && row.gotenna_version">, </template
        >{{ row.build_number }}
    </span>
</template>

<script>
export default {
    props: ['row'],
}
</script>
